import { hFetch } from '@/lib/hfetch';
import type { PipelineReviewContactConfigurationEntity } from '@/api/entity_types/pipeline_review/ContactConfiguration';

export type BatchUpdateTarget = { ids: number[] } | { all: true };

export const batchUpdateContactConfigurations = async (
  target: BatchUpdateTarget,
  params: Partial<PipelineReviewContactConfigurationEntity>
) => {
  return await hFetch({
    url: '/api/pipeline_review/contact_configurations/batch',
    method: 'PATCH',
    payload: { ...target, pipeline_review_contact_configuration: params },
  });
};
